module.exports = __webpack_public_path__ + "img/LUB00395.5a47e9d7.png";